<div class="row" style="margin:10px">
  <div class="col-11"></div>
  <div class="col-1">
    <button class="btn btn-primary" (click)="goBack()" style="cursor:pointer;">Back
      <span class="material-icons" style="font-size:10px">
        arrow_back
      </span>
    </button>
  </div>
</div>
<div class="row" style="margin:15px">
  <div class="col-6">
    <form [formGroup]="form" (ngSubmit)="submitForm()">
      @if (!this.form.get('FileSearch')?.value) {
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="textToSummarize">Text to be summarized</label>
              <textarea class="form-control" formControlName="summarize_text" id="textToSummarize" rows="16"></textarea>
              @if (form.get('summarize_text')?.invalid && (form.get('summarize_text')?.dirty || form.get('summarize_text')?.touched)) {
                <div style="color:red">
                  Please enter text to be summarized.
                </div>
              }
            </div>
          </div>
        </div>
      }
      <div class="row" style="margin-left:0px">
        <div class="col-12">
          <div class="form-group">
            <input formControlName="FileSearch" class="form-check-input" type="checkbox" id="gridCheck">
            <label class="form-check-label" for="gridCheck">
              Check here to summarize multiple text entries?
            </label>
          </div>

        </div>


      </div>
      @if (this.form.get('FileSearch')?.value) {
        <div class="row" style="margin-left:0px">
          <div class="col-12">
            <div class="form-group">
              <input type="file" formControlName="summarize_text_file" (change)="uploadFile($event)">
              @if (form.get('summarize_text_file')?.invalid && (form.get('summarize_text_file')?.dirty || form.get('summarize_text_file')?.touched)) {
                <div style="color:red">
                  Please upload a valid csv file.
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (this.form.get('FileSearch')?.value) {
        <div class="row" style="margin-left:0px">
          <div class="col-12">
            <a href="#">Click here to download the template file</a>
          </div>
        </div>
      }

      <div class="row" style="margin-top:10px">
        <div class="col-4">
          <div class="form-group">
            <button class="btn btn-primary btn-block btn-lg">Summarize</button>
          </div>
        </div>
      </div>

    </form>
  </div>


  @if (summarizedText!=='' && summarizedText!==undefined) {
    <div class="col-6">
      <div class="form-group">
        <label for="summarizedText">Summarized text</label>
        <textarea class="form-control" [(ngModel)]="summarizedText" id="summarizedText" rows="16"></textarea>
      </div>
    </div>
  }

  <div class="col-6" [hidden]="!dataSource">
    <h4 style="color:#007bff;font-weight:450">Text Summarization Results
    </h4>

    <div class="wrapper">
      <div class="row">
        <div class="col-3">

        </div>
      </div>
      <div class="row" style="margin-bottom:10px">
        <div class="col-5">
          <button class="btn btn-primary btn-block float-right" style="font-size:14px" (click)="exporter.exportTable('xlsx',{fileName:'textSummarization_data',sheet:'textSummarization'})">
            Download Results
            <span class="material-icons">
              arrow_circle_down
            </span>

          </button>
        </div>


      </div>

      <div>
        <mat-table matTableExporter #exporter="matTableExporter" [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="originalText">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Original Text </th>
            <td mat-cell *matCellDef="let element"> {{element.originalText}} </td>
          </ng-container>
          <ng-container matColumnDef="summarizedText">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Summarized Text </th>
            <td mat-cell *matCellDef="let element"> {{element.jobDescription}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </mat-table>
        <table>
          @if (!dataSource) {
            <tr>
              <td style="text-align: center;" [attr.colspan]="displayedColumns.length">
                No Records Found!
              </td>
            </tr>
          }
        </table>
        <!-- Angular 8 pagination -->
        <mat-paginator [hidden]="!dataSource" [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator>
      </div>

    </div>
  </div>



</div>

<div  [style.display] = "ShowLoader">
  <div class="background-image"></div>
  <div id="loader">


  </div>
  <div class="loading">Loading results</div>
</div>
